import { filterValues } from 'utils/object'

import {
  deleteInterviewTemplateQuestion,
  deleteInterviewTemplateSection,
  postInterviewTemplateQuestion,
  postInterviewTemplateSection,
  updateInterviewTemplate,
  updateInterviewTemplateQuestion,
  updateInterviewTemplateSection,
} from 'api/interviewTemplates'

type TemplateQuestion = {
  uuid?: string
  description?: string
  order?: number
  question?: string
}

type SavedQuestion = TemplateQuestion & { uuid: string }

// NOTE: hook that gathers all the data mutation handlers
// which call api with methods like POST, PATCH, PUT, DELETE
// and exposes them for local hooks
export const useMutations = () => {
  const handleDeleteTemplateQuestion = async ({
    questions = [],
  }: {
    questions?: SavedQuestion[]
  }) =>
    await Promise.all(
      questions.map(
        async ({ uuid }) => await deleteInterviewTemplateQuestion({ uuid }),
      ),
    )

  const handlePostTemplateQuestion = async ({
    questions = [],
    sectionUrl,
  }: {
    questions?: TemplateQuestion[]
    sectionUrl: string
  }) =>
    await Promise.all(
      questions.map(
        async ({ description, order, question }) =>
          await postInterviewTemplateQuestion({
            description,
            order: order as number,
            section: sectionUrl,
            title: question as string,
          }),
      ),
    )

  const handlePatchTemplateQuestion = async ({
    questions = [],
  }: {
    questions?: SavedQuestion[]
  }) =>
    await Promise.all(
      questions.map(
        async ({ uuid, description, order, question }) =>
          await updateInterviewTemplateQuestion({
            description,
            order: order as number,
            title: question as string,
            uuid,
          }),
      ),
    )

  const handleDeleteTemplateSection = async ({ uuid }) =>
    await deleteInterviewTemplateSection({ uuid })

  const handlePostTemplateSection = async ({
    description,
    interviewTemplate,
    key,
    order,
    scoreable,
    title,
  }) =>
    await postInterviewTemplateSection({
      description,
      interviewTemplate,
      key,
      order,
      scoreable,
      title,
    })

  const handlePatchTemplateSection = async ({
    order,
    scoreable,
    title,
    uuid,
  }) => await updateInterviewTemplateSection({ order, scoreable, title, uuid })

  const handlePatchTemplate = async ({
    skills,
    title,
    uuid,
  }: {
    skills?: any
    title?: string
    uuid: string
  }) =>
    await updateInterviewTemplate({
      payload: filterValues({ title, skills }, value => value != null),
      uuid,
    })

  return {
    handleDeleteTemplateQuestion,
    handleDeleteTemplateSection,
    handlePatchTemplate,
    handlePatchTemplateQuestion,
    handlePatchTemplateSection,
    handlePostTemplateQuestion,
    handlePostTemplateSection,
  }
}
